export default __webpack_public_path__ + "static/media/RECLAMATION.2b052a3b.svg";